import React, { Component } from 'react';
//Images
import Placeholder from '../../../images/placeholder.png';
import Atom from '../../../images/icon-atom.png';

//Components
import GlobalColors from '../atoms/GlobalColors';
import GlobalFonts from '../atoms/GlobalFonts';
import TextParagraph from '../atoms/TextParagraph';
import TextHeadingOne from '../atoms/TextHeadingOne';
import TextHeadingTwo from '../atoms/TextHeadingTwo';
import TextHeadingThree from '../atoms/TextHeadingThree';
import TextHeadingFour from '../atoms/TextHeadingFour';
import TextAnchor from '../atoms/TextAnchor';
import TextBlockquote from '../atoms/TextBlockquote';
import Button from '../atoms/Button';
import FormButton from '../atoms/FormButton';
import FormTextfield from '../atoms/FormTextfield';
import FormInputWords from '../atoms/FormInputWords';
import FormLabel from '../atoms/FormLabel';
import FormErrorMessage from '../atoms/FormErrorMessage';
import FormTextarea from '../atoms/FormTextarea';
import FormMinimalTextarea from '../atoms/FormMinimalTextarea';
import FormSelect from '../atoms/FormSelect';
import FormRadio from '../atoms/FormRadio';
import FormCheckbox from '../atoms/FormCheckbox';
import FormToggleSwitch from '../atoms/FormToggleSwitch';
import ImageLandscape from '../atoms/ImageLandscape';
import ImagePortrait from '../atoms/ImagePortrait';
import ImageSquare from '../atoms/ImageSquare';
import ImageAvatar from '../atoms/ImageAvatar';
import Image from '../atoms/Image';
import Icon from '../atoms/Icon';



//Returning the component
class Atoms extends Component {
	render() {
		return (
			<div className="styleguide">
				<div className="sidebar textSmall">
					<div className="sidebar__wrapper">
						<div className="sidebar__atomicPage">
						<h1 className="textHeadingOne color-primary">
								<a href="/Atoms/">Atoms </a>
								<i className="fa fa-angle-down sidebar__atomicPageIcon" aria-hidden="true"></i>
							</h1>
							<h1 className="textHeadingOne color-primary">
								<a href="/Molecules/">Molecules</a>
				
							</h1>
							<h1 className="textHeadingOne color-primary">
								<a href="/Organisms/">Organisms</a>
							</h1>
						</div>
						<ul className="sidebar__menu">
							<ul className="sidebar__chapter">
								<h3 className="textHeadingThree sidebar_chapterHeading">Global style</h3>
								<li className="sidebar__chapterList">
									<a href="#grid" className="sidebar__link color-primary">Grid</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#colors" className="sidebar__link color-primary">Colors</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#fonts" className="sidebar__link color-primary">Fonts</a>
								</li>
							</ul>
							<ul className="sidebar__chapter">
								<h3 className="textHeadingThree sidebar_chapterHeading">Buttons</h3>
								<li className="sidebar__chapterList">
									<a href="#buttonSize" className="sidebar__link color-primary">Button size</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#buttonState" className="sidebar__link color-primary">Button state</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#buttonIcon" className="sidebar__link color-primary">Button icon</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#buttonStyle" className="sidebar__link color-primary">Button style</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#buttonColor" className="sidebar__link color-primary">Button color</a>
								</li>
							</ul>

							<ul className="sidebar__chapter">
								<h3 className="textHeadingThree sidebar_chapterHeading">Forms</h3>
								<li className="sidebar__chapterList">
									<a href="#textfield" className="sidebar__link color-primary">Textfield</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#label" className="sidebar__link color-primary">Label</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#message" className="sidebar__link color-primary">Message</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#textarea" className="sidebar__link color-primary">Textarea</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#select" className="sidebar__link color-primary">Select</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#radio" className="sidebar__link color-primary">Radio</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#checkbox" className="sidebar__link color-primary">Checkbox</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#formButton" className="sidebar__link color-primary">Form button</a>
								</li>
							</ul>
							<ul className="sidebar__chapter">
								<h3 className="textHeadingThree sidebar_chapterHeading">Typography</h3>
								<li className="sidebar__chapterList">
									<a href="#heading" className="sidebar__link color-primary">Heading</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#paragraph" className="sidebar__link color-primary">Paragraph</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#anchor" className="sidebar__link color-primary">Anchor</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#blockquote" className="sidebar__link color-primary">Blockquote</a>
								</li>
							</ul>
							<ul className="sidebar__chapter">
								<h3 className="textHeadingThree sidebar_chapterHeading">Image</h3>
								<li className="sidebar__chapterList">
									<a href="#imageLandscape" className="sidebar__link color-primary">Image landscape</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#imagePortrait" className="sidebar__link color-primary">Image portrait</a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#imageSquare" className="sidebar__link color-primary">Image square </a>
								</li>
								<li className="sidebar__chapterList">
									<a href="#imageAvatar" className="sidebar__link color-primary">Image avatar</a>
								</li>
							</ul>
						</ul>
					</div>
				</div>
				<div className="styleguide__container">
					<div className="styleguide__section">
						<div className="styleguide__header">
							<Image classType="atomicDesign_headerImage" src={Atom} alt="Atoms" />
							<h1 className="textHeadingOne color-black">Atoms</h1>
						</div>
						<section className="chapter">
							<div className="chapter__header">
								<h1 className="textHeadingOne">Global style</h1>
							</div>
							<div className="chapter__content">
								<div className="chapter__section">
									<div className="chapter__description">

										<div className="chapter__filepath">
											<p className="textCode">CSS: ./src/styles/scss/00_base/bootstrap4/_bootstrap-grid.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="grid">Grid</h3>
									<p>
										Add
								<code>col</code> class to every column. Size it using responsive classes, where
								<code>#</code> is a number from 0 to 12
								<br />
										<code>xs-#</code>
										<code>sm-#</code>
										<code>md-#</code>
										<code>lg-#</code>
										<code>xl-#</code>
									</p>
									<p>Offsets are also available by adding
								<br />
										<code>offset-xm-#</code>
										<code>offset-sm-#</code>
										<code>offset-md-#</code>
										<code>offset-lg-#</code>
										<code>offset-xl-#</code>
									</p>
									<div className="row row-border margin-bottom-20 margin-x-0">
										<div className="column col-md-1">1</div>
										<div className="column col-md-1">1</div>
										<div className="column col-md-1">1</div>
										<div className="column col-md-1">1</div>
										<div className="column col-md-1">1</div>
										<div className="column col-md-1">1</div>
										<div className="column col-md-1">1</div>
										<div className="column col-md-1">1</div>
										<div className="column col-md-1">1</div>
										<div className="column col-md-1">1</div>
										<div className="column col-md-1">1</div>
										<div className="column col-md-1">1</div>
									</div>
									<div className="row row-border margin-bottom-20 margin-x-0">
										<div className="column col-md-4">4</div>
										<div className="column col-md-4">4</div>
										<div className="column col-md-4">4</div>
									</div>
									<div className="row row-border margin-bottom-20 margin-x-0">
										<div className="column col-md-6">6</div>
										<div className="column col-md-6">6</div>
									</div>
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/GlobalColors.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/_1-GlobalColors.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="colors">Colors</h3>
									<GlobalColors />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/GlobalFonts.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/00_base/_typography.scss</p>
											<p className="textCode">CSS: ./src/styles/scss/00_base/assets/typi/_typi.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="fonts">Fonts</h3>
									<GlobalFonts />
								</div>
							</div>
						</section>
						<section className="chapter">
							<div className="chapter__header">
								<h1 className="textHeadingOne">Buttons</h1>
							</div>
							<div className="chapter__content">
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/Button.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/buttonAnchor.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="buttonSize">Button size</h3>
									<Button classType="btn--small" text="Small" href="#clicked" />
									<Button classType="btn--medium" text="Medium" href="#clicked" />
									<Button classType="btn--large" text="Large" href="#clicked" />
									<Button classType="btn--jumbo" text="Jumbo" href="#clicked" />
									<Button classType="btn--mega" text="Large" href="#clicked" />
									<h3 className="textHeadingThree subChapter" id="buttonState">Button state</h3>
									<Button classType="btn--small" text="Default" href="#clicked" />
									<Button classType="btn--small btn--hover" text="Hover" href="#clicked" />
									<Button classType="btn--small btn--pressed" text="Hover" href="#clicked" />
									<Button classType="btn--small btn--focused" text="Hover" href="#clicked" />
									<Button classType="btn--small btn--disabled" text="Hover" href="#clicked" />
									<h3 className="textHeadingThree subChapter" id="buttonIcon">Button icon</h3>
									<Button classType="btn btn--small btn--IconLeft" text="Left icon" href="#clicked" iconLeft="fa-check" />
									<Button classType="btn btn--small btn--IconRight" text="Right icon" href="#clicked" iconRight="fa-check" />
									<h3 className="textHeadingThree subChapter" id="buttonStyle">Button style</h3>
									<Button classType="btn--small" text="Default + background" href="#clicked" />
									<Button classType="btn--small btn--border" text="Border + background" href="#clicked" />
									<Button classType="btn--small btn--borderTransparent" text="Border + transparent" href="#clicked" />
									<h3 className="textHeadingThree subChapter" id="buttonColor">Button color</h3>
									<Button classType="btn--small" text="Primary" href="#clicked" />
									<Button classType="btn--small btn--success" text="Success" href="#clicked" />
									<Button classType="btn--small btn--warning" text="Warning" href="#clicked" />
									<Button classType="btn--small btn--error" text="Error" href="#clicked" />
								</div>
							</div>
						</section>
						<section className="chapter">
							<div className="chapter__header">
								<h1 className="textHeadingOne">Forms</h1>
							</div>
							<div className="chapter__content">
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/FormTextfield.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/form.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="textfield">Textfield</h3>
									<FormTextfield classType="default" id="default" placeholder="default" name="default" />
									<FormTextfield classType="form--error" id="error" placeholder="error" name="error" />
									<FormTextfield classType="form--disabled" id="disabled" placeholder="disabled" name="disabled" />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/FormLabel.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/form.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="label">Label</h3>
									<FormLabel for="Default" text="Default" />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/FormErrorMessage.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/form.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="message">Message</h3>
									<FormErrorMessage text="Error" />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/FormTextarea.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/form.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="textarea">Textarea</h3>
									<FormTextarea classType="Default" placeholder="Default" />
									<FormTextarea classType="form--disabled" placeholder="Disabled" />
									<h3 className="textHeadingThree subChapter" id="textarea">Minimal textarea</h3>
									<FormMinimalTextarea classType="Default" placeholder="Default" />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/FormSelect.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/form.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="select">Select</h3>
									<FormSelect>
										<option>Default</option>
										<option>Default</option>
										<option>Default</option>
									</FormSelect>
									<FormSelect classType="form--disabled">
										<option>Disabled</option>
										<option>Disabled</option>
										<option>Disabled</option>
									</FormSelect>
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/FormRadio.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/form.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="radio">Radio</h3>
									<FormRadio classType="Default" option="Default" />
									<FormRadio classType="form--disabled" option="Disabled" />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/FormCheckbox.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/form.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="checkbox">Checkbox</h3>
									<FormCheckbox classType="Default" option="Default" />
									<FormCheckbox classType="form--disabled" option="Disabled" />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/FormToggleSwitch.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/form.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="toggleSwitch">Toggle switch</h3>
								<FormToggleSwitch/>
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/FormCheckbox.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/form.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="formButton">Form button</h3>
									<FormButton classType="block" type="submit" form="default" text="Submit" />
								</div>
							</div>
						</section>
						<section className="chapter">
							<div className="chapter__header">
								<h1 className="textHeadingOne">Typography</h1>
							</div>
							<div className="chapter__content">
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/textHeading*(One,Two,Three,Four).jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/00_base/_typography.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="heading">Heading</h3>
									<TextHeadingOne text="Heading 1" />
									<TextHeadingTwo text="Heading 2" />
									<TextHeadingThree text="Heading 3" />
									<TextHeadingFour text="Heading 4" />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">

										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/textParagraph.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/00_base/_typography.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="paragraph">Paragraph</h3>
									<TextParagraph text="Paragraph" />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/TextAnchor.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/00_base/_typography.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="anchor">Anchor</h3>
									<TextAnchor href="#clicked" text="Anchor" />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">

										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/TextBlockquote.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/00_base/_typography.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="blockquote">Blockquote</h3>
									<TextBlockquote text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." />
								</div>
							</div>
						</section>
						<section className="chapter">
							<div className="chapter__header">
								<h1 className="textHeadingOne">Images</h1>
							</div>
							<div className="chapter__content">
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/ImageLandscape.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/_a-image.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="imageLandscape">Image landscape</h3>
									<ImageLandscape src={Placeholder} alt="Placeholder" />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/ImagePortrait.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/_a-image.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="imagePortrait">Image portrait</h3>
									<ImagePortrait src={Placeholder} alt="Placeholder" />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/ImageSquare.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/_a-image.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="imageSquare">Image square</h3>
									<ImageSquare src={Placeholder} alt="Placeholder" />
								</div>
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/ImageAvatar.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/_a-image.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="imageAvatar">Image Avatar</h3>
									<ImageAvatar src={Placeholder} alt="Placeholder" />
								</div>
							</div>
						</section>
						<section className="chapter">
							<div className="chapter__header">
								<h1 className="textHeadingOne">Icons</h1>
							</div>
							<div className="chapter__content">
								<div className="chapter__section">
									<div className="chapter__description">
										<div className="chapter__filepath">
											<p className="textCode">Component: ./src/redux/components/atoms/Icon.jsx </p>
											<p className="textCode">CSS: ./src/styles/scss/01_atoms/_a-icon.scss</p>
										</div>
									</div>
									<h3 className="textHeadingThree subChapter" id="icon">Icon</h3>
									<Icon classType="fa-check" />
									<h3 className="textHeadingThree subChapter" id="iconSize">Icon size</h3>
									<Icon classType="fa-check fa--textParagraph" />
									<Icon classType="fa-check fa--textHeadingFour" />
									<Icon classType="fa-check fa--textHeadingThree" />
									<Icon classType="fa-check fa--textHeadingTwo" />
									<Icon classType="fa-check fa--textHeadingOne" />
									<Icon classType="fa-check fa--textJumbo" />
									<Icon classType="fa-check fa--textMega" />
								</div>

								<h3 className="textHeadingThree subChapter" id="">Input words</h3>
									<FormInputWords placeholder="word" classType="default" id="default" name="default" />
							</div>
						</section>
					</div>
				</div>
			</div>
		)
	}
}

export default Atoms;


// WEBPACK FOOTER //
// ./src/redux/components/templates/Atoms.jsx